
/**
 * Modelo dos dados de uma empresa
 */
class Empresa {

    /**
     * Cria uma nova instância de empresa
     * @param {Number|null} id Identificação da empresa
     * @param {String|null} nome Nome da empresa
     */
    constructor(id, nome) {
        /** @member {Number|null} id Identificação da empresa */
        this.id = id ?? null;
        /** @member {String|null} nome Nome da empresa */
        this.nome = nome ?? null;
    }

    /**
     * Copia os dados para um novo objeto
     * @param {Empresa} empresa Objeto a ser clonado
     * @returns {Empresa} Retorna um objeto com os mesmos dados do original
     */
    static clone(empresa) {
        return new Empresa(empresa.id, empresa.nome);
    }
}

export default Empresa;